import React from 'react';
import { observer } from 'mobx-react-lite';
import cartStore from '../../../stores/CartStore';

interface CartIconProps {
  onClick?: () => void;
}

const CartIcon: React.FC<CartIconProps> = observer(({ onClick }) => {
  // Sum up the total quantity from cartStore
  const itemCount = cartStore.totalQuantity;

  return (
    <div
      className="relative cursor-pointer"
      onClick={onClick}
      aria-label="View Cart"
      title="View Cart"
    >
      {/* The base SVG (the cart + bubble shape). 
          If your CartBubble.svg is *only* the cart shape, 
          you might need to manually position a badge. 
      */}
      <img
        src="https://santaplaya-bucket.s3.amazonaws.com/CartIcon.webp"
        className="w-10 h-10"
      />
      <span
        className="absolute top-0 right-0 transform translate-x-1/2 -translate-y-1/2
                   bg-maroon text-white text-xs w-5 h-5 rounded-full flex items-center justify-center"
      >
        {itemCount}
      </span>
    </div>
  );
});

export default CartIcon;
